import React                      from 'react'
import { Select }                 from 'antd'
import { SelectProps }            from 'antd/lib/select'
import { Observer }               from 'mobx-react'

import { FACTORY
       , MApp }                   from '../09_model_app'

export const SelectWorkgroup: React.FC< SelectProps > = ( props ) =>
<Observer render={ ( ) => 
{
  const user       = MApp( ).user
      , workgroups = FACTORY.WORKGROUPS.data_for( { cloud_id: user? user.workgroup.cloud.id : 0 }, 0 ) ;

  // TODO LOCALE: Cannot change the "No data" message that appears when workgroups.data.length === 0
  return <Select loading={ workgroups.loading } {...props}>
   { workgroups.data.map( group =>
      <Select.Option value={ group.id } key={ group.id }>{ group.name }</Select.Option>
   ) }
  </Select> ;
}} />
